import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IDocumentDetailRootDTO } from 'app/main/pages/documents/dto/document-details.dto';
import { FieldActionEvent } from '../dynamic-field.component';
import { CommonModule } from '@angular/common';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';

@Component({
  selector: 'app-language-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './language-field.component.html',
  styleUrl: './language-field.component.scss'
})
export class LanguageFieldComponent {

  @Input() formGroup!: FormGroup;
  @Input() documentData: IDocumentDetailRootDTO;
  @Input() canEdit: boolean = true;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();
  @Input()
  set field(value: IField) {
    this._field = structuredClone(value);
  }

  get field(): IField {
    return this._field;
  }


  public _field: IField;

  public languages = [
    { id: 1, name: 'English', value: 'english' },
    { id: 2, name: 'Swedish', value: 'swedish' },
    { id: 3, name: 'German', value: 'german' },
    { id: 4, name: 'Finnish', value: 'finnish' },
    { id: 5, name: 'French', value: 'french' },
    { id: 6, name: 'Norwegian', value: 'norwegian' },
    { id: 7, name: 'Danish', value: 'danish' },
    { id: 8, name: 'Spanish', value: 'spanish' }
  ];

  onLanguageChange($event: { id: number, name: string, value: string }): void {
    this.actionEmit.emit({ action: 'onLanguageChange', data: $event });
  }
}
